module.exports = __webpack_public_path__ + "img/pic16.7af059dd.png";